import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntersectionObserver } from '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/analytics';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import '../../../types/product.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/state';
import '../../../modules/ClickAndReserve/context/ClickAndReserveGlobalContext/ClickAndReserveGlobalContext.js';
import '@grandvisionhq/stores-v2';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/auth';
import '@grandvisionhq/elements';
import { useProductDetailLayoutSlots } from '../../../slots/context.js';
import '../../../hooks/useCartDiscountsQuery/types.js';
import '../../../operations/queries/get-accessories-by-slug.js';
import '../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../operations/queries/get-frames-by-slug.js';
import '../../../operations/queries/get-solutions-by-slug.js';
import '../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../operations/queries/get-manufacturer-by-key.js';
import '../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/inventory';
import '@grandvisionhq/svc-tealium/components';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/reviews';
import '../../../modules/ProductImageGallery/slots/context.js';
import 'react-zoom-pan-pinch';
import { StickyAside } from '../../../modules/StickyAside/StickyAside.js';
import '../../../modules/VTO/context/VtoProvider.js';
import '../../../modules/SSP/constants/sorting.js';
import '../../../modules/SSP/types/types.js';
import { ProductDetailStack } from './components/ProductDetailStack/ProductDetailStack.js';

const ProductDetailLayout = ()=>{
    const { Slots  } = useProductDetailLayoutSlots();
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const [ctaRef, ctaInview] = useIntersectionObserver();
    const showStickyButton = React.useMemo(()=>isMobile && !ctaInview
    , [
        isMobile,
        ctaInview
    ]);
    if (isMobile) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "pdp-layout-mobile",
            "data-t": "pdp-layout"
        }, /*#__PURE__*/ React.createElement(ProductDetailFullWidth, null, /*#__PURE__*/ React.createElement(Slots.ImageGallery, null)), /*#__PURE__*/ React.createElement(ProductDetailStack, {
            spacing: "half"
        }, /*#__PURE__*/ React.createElement(Slots.ProductTitle, null), /*#__PURE__*/ React.createElement(Slots.StarRatingReview, null)), /*#__PURE__*/ React.createElement(Slots.EcommContent, {
            ctaRef: ctaRef,
            className: "pdp-layout-mobile__ecomm-content"
        }), /*#__PURE__*/ React.createElement(ProductDetailContainedWidth, null, /*#__PURE__*/ React.createElement(Slots.Usps, null)), /*#__PURE__*/ React.createElement(Slots.PrimaryProductInfo, null), showStickyButton && /*#__PURE__*/ React.createElement(Slots.StickyCta, {
            className: "pdp-layout-mobile__sticky-cta"
        }), Slots.SecondaryProductInfo && /*#__PURE__*/ React.createElement(Slots.SecondaryProductInfo, null), /*#__PURE__*/ React.createElement(Slots.Analytics, null));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "pdp-layout",
        "data-t": "pdp-layout"
    }, /*#__PURE__*/ React.createElement(ProductDetailContainedWidth, {
        className: "pdp-layout__sticky-scroll-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pdp-layout__info"
    }, /*#__PURE__*/ React.createElement(Slots.ImageGallery, null), /*#__PURE__*/ React.createElement(Slots.PrimaryProductInfo, null)), /*#__PURE__*/ React.createElement("aside", {
        className: "pdp-layout__ecomm-aside"
    }, /*#__PURE__*/ React.createElement(StickyAside, {
        bottomBoundary: ".pdp-layout__sticky-scroll-wrapper",
        isEnabled: true
    }, /*#__PURE__*/ React.createElement(ProductDetailStack, {
        spacing: "half"
    }, /*#__PURE__*/ React.createElement(Slots.ProductTitle, null), /*#__PURE__*/ React.createElement(Slots.StarRatingReview, null)), /*#__PURE__*/ React.createElement(Slots.EcommContent, {
        className: "pdp-layout__ecomm-content"
    }), /*#__PURE__*/ React.createElement(Slots.Usps, null)))), Slots.SecondaryProductInfo && /*#__PURE__*/ React.createElement(Slots.SecondaryProductInfo, null), /*#__PURE__*/ React.createElement(Slots.Analytics, null));
};
const ProductDetailFullWidth = ({ children , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('pdp-layout--full-width', className)
    }, children)
;
const ProductDetailContainedWidth = ({ children , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('pdp-layout--contained-width', className)
    }, children)
;
const ProductDetailCenteredElements = ({ children , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('pdp-layout--centered-elements', className)
    }, children)
;
const ProductDetailVerticalSpacer = ({ h  })=>/*#__PURE__*/ React.createElement("span", {
        style: {
            height: `${h}rem`
        },
        className: "pdp-layout--vertical-spacer"
    })
;

export { ProductDetailCenteredElements, ProductDetailContainedWidth, ProductDetailFullWidth, ProductDetailLayout, ProductDetailVerticalSpacer };
//# sourceMappingURL=ProductDetailLayout.js.map
